import { TraceNodeListComponent } from './trace-node-list/trace-node-list.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TraceService } from './core/services/trace.service';
import { Trace } from './core/viewmodels/trace';
import { Store } from '@ngrx/store';
import { TraceActions } from './core/reducers/trace.actions';
import { ViewerActions } from './core/reducers/viewer.actions';
import { Config } from './core/config';
import { IAppState } from 'app/IAppState';
import { Router } from '@angular/router';

@Component({
  selector: 'biz-trace-management',
  templateUrl: './trace-management.component.html',
  styleUrls: ['./trace-management.component.scss']

})
export class TraceManagementComponent implements OnInit {
  @ViewChild('traceNodeList', { static: false }) traceNodeList: TraceNodeListComponent;

  private _trace: Trace;
  private _nodes: Array<ITraceNode>;
  public showLoading = true;
  public viewerActive = true;
  public configActive = false;
  public selectedTab: number = 0;
  public showTraceImprovement: boolean = false;

  constructor(
    private _dataService: TraceService,
    private _store: Store<IAppState>,
    private _traceActions: TraceActions,
    private _viewerActions: ViewerActions,
    private router: Router
  ) {
    this._store.dispatch(this._viewerActions.Activated('Viewer'));
    if (this.router.url.includes('TracingManagement'))
      this.showTraceImprovement = true;
  }

  ngOnInit() {
    this.getTrace();

    this._store.select((s) => s.stateTrace)
      .subscribe((value: IStateTrace) => {
        if (value.changeState) {
          if (value.nodes[Config.MODULENAME]) {
            this._nodes = value.nodes[Config.MODULENAME];
            this.showLoading = false;
          } else {
            this.getTrace();
          }
        }
      });

    this._store
      .select((s) => s.stateViewer)
      .subscribe((value: IStateViewer) => {
        this.configActive = value.active === 'Config';
        this.viewerActive = !this.configActive;
      });
  }

  public viewerClicked() {
    this._store.dispatch(this._viewerActions.Activated('Viewer'));
  }

  public configClicked() {
    this._store.dispatch(this._viewerActions.Activated('Config'));
  }

  private getTrace() {
    this._dataService.getTraceConfiguration()
      .subscribe(
        (res: ITrace) => {
          this._trace = new Trace(res);
          this._nodes = this._trace.Tracing;

          this._store.dispatch(this._traceActions.Update(Config.MODULENAME, this._nodes, true));
        },
        (error) => this.showLoading = false,
        () => {
          this.showLoading = false
        }
      );
  }
}
